module.exports = __webpack_public_path__ + "static/media/why-image.f0d1361e.png";